export default __webpack_public_path__ + "static/media/wkf2.c4edc613.png";